import { useStripe } from '@stripe/react-stripe-js';
import { StripeElements } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { API_URL } from '../../../utils/constants';
import { Button } from '@wot/components';
import { IPlan } from '@wot/typings';
import { currencyFormatter } from '../../../utils/functions';
import useCurrency from '../../../hooks/useCurrency';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

const PaymentForm = ({ plan, grandTotal }: { plan: IPlan; grandTotal: number }) => {
  const stripe = useStripe();
  const convertAmount = useCurrency();
  // let elements = useElements()
  const [processing, setProcessing] = useState(false);
  const [message, setMessage] = useState('');
  const [clientSecret, setClientSecert] = useState('');
  const [elements, setElements] = useState<StripeElements>();

  useEffect(() => {
    console.log('render paymentform');
    if (plan._id) {
      fetch(`${API_URL}/u/paymentInit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          amount: grandTotal,
          currency: 'inr',
          userId: plan.userId,
          planId: plan._id
        })
      })
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          if (res.status === 'OK') setClientSecert(res.data.clientSecret);
        });
    }
  }, [plan]);

  useEffect(() => {
    if (stripe) {
      if (clientSecret) {
        let elements = stripe.elements({
          clientSecret: clientSecret
        });
        setElements(elements);
        var paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');
      }
    }
  }, [clientSecret]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    let redirect_url = `${window.location.origin}/buy-plan/checkout-processing?planId=${plan._id}`;
    setProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: redirect_url
      }
    });

    if (error) {
      console.log(error.message);
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  };

  return (
    <>
      {clientSecret ? (
        <form onSubmit={handleSubmit} className="w-full h-full">
          <div id="payment-element"></div>
          <div className="my-2">
            <Button loading={processing} text={`Pay ${convertAmount(plan.totalCost).amountString}`} type="primary" />
          </div>
        </form>
      ) : (
        // : processing ?
        //   <div className='w-full h-full min-h-screen bg-black/25 z-50 flex items-center justify-center'>
        //     <div className="w-full h-max max-w-md mx-auto p-7 bg-white rounded-2xl">
        //       <div className="w-full flex flex-col items-center justify-center">
        //         {processing ?
        //           <>
        //             <h1 className='text-xl font-semibold my-4'>Processing...</h1>
        //             <img src={LOADERPRIMARY} alt="loading" className='w-14' />
        //           </>
        //           :
        //           <>
        //             {/* <img src={CHECK_ICON} alt="loading" className='w-14' /> */}
        //             <h1>{message}</h1>
        //           </>
        //         }
        //       </div>
        //     </div>
        //   </div>
        <div className="w-full h-full flex items-center justify-center">
          {/* <img src={LOADERPRIMARY} alt="loading" className='w-14' /> */}
          <p>Loading...</p>
        </div>
      )}
    </>
  );
};

export default PaymentForm;
